import { render, staticRenderFns } from "./CommentCodeBlock.vue?vue&type=template&id=19ce4ada&scoped=true&"
import script from "./CommentCodeBlock.vue?vue&type=script&lang=ts&"
export * from "./CommentCodeBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CommentCodeBlock.vue?vue&type=style&index=0&id=19ce4ada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce4ada",
  null
  
)

export default component.exports